const COURSE_LIST = 'COURSE_LIST'
const COURSE_LIST_SUCCESS = 'COURSE_LIST_SUCCESS'
const COURSE_LIST_ERROR = 'COURSE_LIST_ERROR'

const COURSE_GET = 'COURSE_GET'
const COURSE_GET_SUCCESS = 'COURSE_GET_SUCCESS'
const COURSE_GET_ERROR = 'COURSE_GET_ERROR'

const COURSE_ADD = 'COURSE_ADD'
const COURSE_ADD_SUCCESS = 'COURSE_ADD_SUCCESS'
const COURSE_ADD_ERROR = 'COURSE_ADD_ERROR'

const COURSE_EDIT = 'COURSE_EDIT'
const COURSE_EDIT_SUCCESS = 'COURSE_EDIT_SUCCESS'
const COURSE_EDIT_ERROR = 'COURSE_EDIT_ERROR'

const COURSE_UPDATE_ATTRIBUTE = 'COURSE_UPDATE_ATTRIBUTE'

const COURSE_PATCH = 'COURSE_PATCH'
const COURSE_PATCH_SUCCESS = 'COURSE_PATCH_SUCCESS'
const COURSE_PATCH_ERROR = 'COURSE_PATCH_ERROR'

const COURSE_REPORT = 'COURSE_REPORT'
const COURSE_REPORT_SUCCESS = 'COURSE_REPORT_SUCCESS'
const COURSE_REPORT_ERROR = 'COURSE_REPORT_ERROR'

const QUESTION_PAYMENT_DATA_UPDATE = 'QUESTION_PAYMENT_DATA_UPDATE'
const QUESTION_PAYMENT_DISCONNECT = 'QUESTION_PAYMENT_DISCONNECT'

const COURSE_SETTING_PATCH = 'COURSE_SETTING_PATCH'
const COURSE_SETTING_PATCH_SUCCESS = 'COURSE_SETTING_PATCH_SUCCESS'
const COURSE_SETTING_PATCH_ERROR = 'COURSE_SETTING_PATCH_ERROR'

const COURSE_SETTING_CREATE = 'COURSE_SETTING_CREATE'
const COURSE_SETTING_CREATE_SUCCESS = 'COURSE_SETTING_CREATE_SUCCESS'
const COURSE_SETTING_CREATE_ERROR = 'COURSE_SETTING_CREATE_ERROR'

const COURSE_SETTING_PATCH_BY_ID = 'COURSE_SETTING_PATCH_BY_ID'
const COURSE_SETTING_PATCH_BY_ID_SUCCESS = 'COURSE_SETTING_PATCH_BY_ID_SUCCESS'
const COURSE_SETTING_PATCH_BY_ID_ERROR = 'COURSE_SETTING_PATCH_BY_ID_ERROR'

const QUESTION_SELECTIONS_ADD = 'QUESTION_SELECTIONS_ADD'
const QUESTION_SELECTIONS_ADD_SUCCESS = 'QUESTION_SELECTIONS_ADD_SUCCESS'
const QUESTION_SELECTIONS_ADD_ERROR = 'QUESTION_SELECTIONS_ADD_ERROR'

const OPENAI_SEND_CARD_REQUEST = 'OPENAI_SEND_CARD_REQUEST'
const OPENAI_SEND_CARD_REQUEST_SUCCESS = 'OPENAI_SEND_CARD_REQUEST_SUCCESS'
const OPENAI_SEND_CARD_REQUEST_ERROR = 'OPENAI_SEND_CARD_REQUEST_ERROR'

const OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST =
  'OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST'
const OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_SUCCESS =
  'OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_SUCCESS'
const OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_ERROR =
  'OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_ERROR'

const OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST =
  'OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST'
const OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_SUCCESS =
  'OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_SUCCESS'
const OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_ERROR =
  'OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_ERROR'

const OPENAI_SEND_COURSE_CREATION_REQUEST =
  'OPENAI_SEND_COURSE_CREATION_REQUEST'
const OPENAI_SEND_COURSE_CREATION_REQUEST_SUCCESS =
  'OPENAI_SEND_COURSE_CREATION_REQUEST_SUCCESS'
const OPENAI_SEND_COURSE_CREATION_REQUEST_ERROR =
  'OPENAI_SEND_COURSE_CREATION_REQUEST_ERROR'

const CLONE_TEMPLATE_COURSE = 'CLONE_TEMPLATE_COURSE'
const CLONE_TEMPLATE_COURSE_SUCCESS = 'CLONE_TEMPLATE_COURSE_SUCCESS'
const CLONE_TEMPLATE_COURSE_ERROR = 'CLONE_TEMPLATE_COURSE_ERROR'

const CREATE_PROMPT_FROM_CARD = 'CREATE_PROMPT_FROM_CARD'
const CREATE_PROMPT_FROM_CARD_SUCCESS = 'CREATE_PROMPT_FROM_CARD_SUCCESS'
const CREATE_PROMPT_FROM_CARD_ERROR = 'CREATE_PROMPT_FROM_CARD_ERROR'

const GET_COURSE_ANALYTICS = 'GET_COURSE_ANALYTICS'
const GET_COURSE_ANALYTICS_SUCCESS = 'GET_COURSE_ANALYTICS_SUCCESS'
const GET_COURSE_ANALYTICS_ERROR = 'GET_COURSE_ANALYTICS_ERROR'

const GET_COURSE_ANALYTICS_REPORT = 'GET_COURSE_ANALYTICS_REPORT'
const GET_COURSE_ANALYTICS_REPORT_SUCCESS =
  'GET_COURSE_ANALYTICS_REPORT_SUCCESS'
const GET_COURSE_ANALYTICS_REPORT_ERROR = 'GET_COURSE_ANALYTICS_REPORT_ERROR'

const GENERATE_QUIZZES_BY_COURSE_ID = 'GENERATE_QUIZZES_BY_COURSE_ID'
const GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS =
  'GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS'
const GENERATE_QUIZZES_BY_COURSE_ID_ERROR =
  'GENERATE_QUIZZES_BY_COURSE_ID_ERROR'

const EXPORT_COURSE_TO_SCORM = 'EXPORT_COURSE_TO_SCORM'
const EXPORT_COURSE_TO_SCORM_SUCCESS = 'EXPORT_COURSE_TO_SCORM_SUCCESS'
const EXPORT_COURSE_TO_SCORM_ERROR = 'EXPORT_COURSE_TO_SCORM_ERROR'

const SETTINGS_DRAWER_OPEN = 'SETTINGS_DRAWER_OPEN'

const GET_COURSE_CREATION_PROGRESS = 'GET_COURSE_CREATION_PROGRESS'
const GET_COURSE_CREATION_PROGRESS_SUCCESS =
  'GET_COURSE_CREATION_PROGRESS_SUCCESS'
const GET_COURSE_CREATION_PROGRESS_ERROR = 'GET_COURSE_CREATION_PROGRESS_ERROR'

const THEME_DRAWER_OPEN = 'THEME_DRAWER_OPEN'

const SECTION_DRAWER_OPEN = 'SECTION_DRAWER_OPEN'

const ANALYTICS_DRAWER_OPEN = 'ANALYTICS_DRAWER_OPEN'

const EDIT_SECTION_ORDER = 'EDIT_SECTION_ORDER'
const EDIT_SECTION_ORDER_SUCCESS = 'EDIT_SECTION_ORDER_SUCCESS'
const EDIT_SECTION_ORDER_ERROR = 'EDIT_SECTION_ORDER_ERROR'

const PATCH_SECTION = 'PATCH_SECTION'
const PATCH_SECTION_SUCCESS = 'PATCH_SECTION_SUCCESS'
const PATCH_SECTION_ERROR = 'PATCH_SECTION_ERROR'

const ADD_SECTION = 'ADD_SECTION'
const ADD_SECTION_SUCCESS = 'ADD_SECTION_SUCCESS'
const ADD_SECTION_ERROR = 'ADD_SECTION_ERROR'

const SET_ENDING_CARD = 'SET_ENDING_CARD'

const CREATE_COURSE = 'CREATE_COURSE'
const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS'
const CREATE_COURSE_ERROR = 'CREATE_COURSE_ERROR'

const GET_COURSE_BY_ID = 'GET_COURSE_BY_ID'
const GET_COURSE_BY_ID_SUCCESS = 'GET_COURSE_BY_ID_SUCCESS'
const GET_COURSE_BY_ID_ERROR = 'GET_COURSE_BY_ID_ERROR'

const GENERATE_CARD = 'GENERATE_CARD'
const GENERATE_CARD_SUCCESS = 'GENERATE_CARD_SUCCESS'
const GENERATE_CARD_ERROR = 'GENERATE_CARD_ERROR'

const AI_INSTRUCTION = 'GENERATE_CARD_ERROR'

export const SET_CARD_CREATION_PROGRESS = 'SET_CARD_CREATION_PROGRESS'
export const SET_CARD_CREATION_PROGRESS_VALUE =
  'SET_CARD_CREATION_PROGRESS_VALUE'

const GET_COURSE_LANDING_PAGE = 'GET_COURSE_LANDING_PAGE'
const GET_COURSE_LANDING_PAGE_SUCCESS = 'GET_COURSE_LANDING_PAGE_SUCCESS'
const GET_COURSE_LANDING_PAGE_ERROR = 'GET_COURSE_LANDING_PAGE_ERROR'

const PATCH_COURSE_LANDING_PAGE = 'PATCH_COURSE_LANDING_PAGE'
const PATCH_COURSE_LANDING_PAGE_SUCCESS = 'PATCH_COURSE_LANDING_PAGE_SUCCESS'
const PATCH_COURSE_LANDING_PAGE_ERROR = 'PATCH_COURSE_LANDING_PAGE_ERROR'

const COURSE_FILTER = 'COURSE_FILTER'
const COURSE_FILTER_SUCCESS = 'COURSE_FILTER_SUCCESS'
const COURSE_FILTER_ERROR = 'COURSE_FILTER_ERROR'

const UPLOAD_VIDEO_SUBTITLE = 'UPLOAD_VIDEO_SUBTITLE'
const UPLOAD_VIDEO_SUBTITLE_SUCCESS = 'UPLOAD_VIDEO_SUBTITLE_SUCCESS'
const DELETE_VIDEO_SUBTITLE = 'DELETE_VIDEO_SUBTITLE'
const DELETE_VIDEO_SUBTITLE_SUCCESS = 'DELETE_VIDEO_SUBTITLE_SUCCESS'
const PATCH_VIDEO_SUBTITLE = 'PATCH_VIDEO_SUBTITLE'
const GET_VIDEO_SUBTITLES = 'GET_VIDEO_SUBTITLES'
const GET_VIDEO_SUBTITLES_SUCCESS = 'GET_VIDEO_SUBTITLES_SUCCESS'

export {
  COURSE_LIST,
  COURSE_LIST_SUCCESS,
  COURSE_LIST_ERROR,
  COURSE_ADD,
  COURSE_ADD_SUCCESS,
  COURSE_ADD_ERROR,
  COURSE_GET,
  COURSE_GET_SUCCESS,
  COURSE_GET_ERROR,
  COURSE_EDIT,
  COURSE_EDIT_SUCCESS,
  COURSE_EDIT_ERROR,
  COURSE_UPDATE_ATTRIBUTE,
  COURSE_PATCH,
  COURSE_PATCH_SUCCESS,
  COURSE_PATCH_ERROR,
  COURSE_REPORT,
  COURSE_REPORT_SUCCESS,
  COURSE_REPORT_ERROR,
  QUESTION_PAYMENT_DATA_UPDATE,
  QUESTION_PAYMENT_DISCONNECT,
  COURSE_SETTING_PATCH,
  COURSE_SETTING_PATCH_SUCCESS,
  COURSE_SETTING_PATCH_ERROR,
  COURSE_SETTING_CREATE,
  COURSE_SETTING_CREATE_SUCCESS,
  COURSE_SETTING_CREATE_ERROR,
  QUESTION_SELECTIONS_ADD,
  QUESTION_SELECTIONS_ADD_SUCCESS,
  QUESTION_SELECTIONS_ADD_ERROR,
  OPENAI_SEND_CARD_REQUEST_ERROR,
  OPENAI_SEND_CARD_REQUEST_SUCCESS,
  OPENAI_SEND_CARD_REQUEST,
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST,
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_SUCCESS,
  OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST_ERROR,
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST,
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_SUCCESS,
  OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST_ERROR,
  OPENAI_SEND_COURSE_CREATION_REQUEST,
  OPENAI_SEND_COURSE_CREATION_REQUEST_SUCCESS,
  OPENAI_SEND_COURSE_CREATION_REQUEST_ERROR,
  CLONE_TEMPLATE_COURSE,
  CLONE_TEMPLATE_COURSE_SUCCESS,
  CLONE_TEMPLATE_COURSE_ERROR,
  CREATE_PROMPT_FROM_CARD,
  CREATE_PROMPT_FROM_CARD_SUCCESS,
  CREATE_PROMPT_FROM_CARD_ERROR,
  GET_COURSE_ANALYTICS,
  GET_COURSE_ANALYTICS_SUCCESS,
  GET_COURSE_ANALYTICS_ERROR,
  GET_COURSE_ANALYTICS_REPORT,
  GET_COURSE_ANALYTICS_REPORT_SUCCESS,
  GET_COURSE_ANALYTICS_REPORT_ERROR,
  GENERATE_QUIZZES_BY_COURSE_ID,
  GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS,
  GENERATE_QUIZZES_BY_COURSE_ID_ERROR,
  EXPORT_COURSE_TO_SCORM,
  EXPORT_COURSE_TO_SCORM_SUCCESS,
  EXPORT_COURSE_TO_SCORM_ERROR,
  SETTINGS_DRAWER_OPEN,
  GET_COURSE_CREATION_PROGRESS,
  GET_COURSE_CREATION_PROGRESS_SUCCESS,
  GET_COURSE_CREATION_PROGRESS_ERROR,
  THEME_DRAWER_OPEN,
  SECTION_DRAWER_OPEN,
  EDIT_SECTION_ORDER,
  EDIT_SECTION_ORDER_SUCCESS,
  EDIT_SECTION_ORDER_ERROR,
  PATCH_SECTION,
  PATCH_SECTION_SUCCESS,
  PATCH_SECTION_ERROR,
  ADD_SECTION,
  ADD_SECTION_SUCCESS,
  ADD_SECTION_ERROR,
  ANALYTICS_DRAWER_OPEN,
  SET_ENDING_CARD,
  CREATE_COURSE,
  CREATE_COURSE_SUCCESS,
  CREATE_COURSE_ERROR,
  GET_COURSE_BY_ID,
  GET_COURSE_BY_ID_SUCCESS,
  GET_COURSE_BY_ID_ERROR,
  GENERATE_CARD,
  GENERATE_CARD_SUCCESS,
  GENERATE_CARD_ERROR,
  AI_INSTRUCTION,
  GET_COURSE_LANDING_PAGE_SUCCESS,
  GET_COURSE_LANDING_PAGE,
  GET_COURSE_LANDING_PAGE_ERROR,
  PATCH_COURSE_LANDING_PAGE,
  PATCH_COURSE_LANDING_PAGE_SUCCESS,
  PATCH_COURSE_LANDING_PAGE_ERROR,
  COURSE_FILTER,
  COURSE_FILTER_SUCCESS,
  COURSE_FILTER_ERROR,
  COURSE_SETTING_PATCH_BY_ID,
  COURSE_SETTING_PATCH_BY_ID_SUCCESS,
  COURSE_SETTING_PATCH_BY_ID_ERROR,
  UPLOAD_VIDEO_SUBTITLE,
  UPLOAD_VIDEO_SUBTITLE_SUCCESS,
  DELETE_VIDEO_SUBTITLE,
  DELETE_VIDEO_SUBTITLE_SUCCESS,
  PATCH_VIDEO_SUBTITLE,
  GET_VIDEO_SUBTITLES,
  GET_VIDEO_SUBTITLES_SUCCESS,
}
